/** First palette open of the day — intelligence-headquarters greeting. */
import React from "react";
import { Sun, Sparkles } from "lucide-react";

const greetingWord = () => {
  const h = new Date().getHours();
  return h < 12 ? "GOOD MORNING" : h < 18 ? "GOOD AFTERNOON" : "GOOD EVENING";
};

export default function MorningGreeting({ callsign, dash, onOpenBrief, onAskOracle }) {
  return (
    <div className="mx-4 mt-2 mb-1 border border-[#D92D20]/35 bg-[#100a06]"
         data-testid="command-morning">
      <div className="px-4 pt-3">
        <div className="font-mono text-[9px] uppercase tracking-[0.4em] text-[#7B7168]">
          {greetingWord()}
        </div>
        <div className="font-mono text-[16px] uppercase tracking-[0.3em] text-[#E4DFD3] mt-0.5"
             data-testid="command-morning-callsign">
          {callsign || "OPERATIVE"}
        </div>
        <div className="font-mono text-[10px] text-[#A39E93] mt-1">
          Oracle has prepared today's Founder Brief.
        </div>
      </div>
      <div className="px-4 py-2 flex flex-wrap gap-3 font-mono text-[9px] text-[#7B7168]">
        {dash?.pending_submissions > 0 && (
          <span className="text-[#E0A526]">▲ {dash.pending_submissions} pending review</span>
        )}
        {dash?.security_alerts_24h > 0 && (
          <span className="text-[#D92D20]">▲ {dash.security_alerts_24h} security events (24h)</span>
        )}
        <span className={dash?.system_health === "nominal" ? "text-[#3FB950]" : "text-[#E0A526]"}>
          ● System {dash?.system_health === "nominal" ? "Nominal" : "Attention"}
        </span>
      </div>
      <div className="px-4 pb-3 flex gap-2">
        <button type="button" onClick={onOpenBrief} data-testid="morning-open-brief"
                className="flex items-center gap-1.5 font-mono text-[9px] uppercase tracking-[0.2em] px-3 py-1.5 border border-[#D92D20] text-[#E4DFD3] bg-[#1a0808] hover:bg-[#D92D20]/20 transition-colors">
          <Sun size={10} /> Open Brief
        </button>
        <button type="button" onClick={onAskOracle} data-testid="morning-ask-oracle"
                className="flex items-center gap-1.5 font-mono text-[9px] uppercase tracking-[0.2em] px-3 py-1.5 border border-[#2D2A26] text-[#A39E93] hover:border-[#D92D20] hover:text-[#E4DFD3] transition-colors">
          <Sparkles size={10} /> Ask Oracle
        </button>
      </div>
    </div>
  );
}
